import { render, staticRenderFns } from "./Codesys.vue?vue&type=template&id=25b09e15&scoped=true"
import script from "./Codesys.vue?vue&type=script&lang=js"
export * from "./Codesys.vue?vue&type=script&lang=js"
import style0 from "./Codesys.vue?vue&type=style&index=0&id=25b09e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b09e15",
  null
  
)

export default component.exports